import { TomamuestraService } from "../../services/models/integrations/tomamuestra";
import { formatRut } from "@/services/utils";
const moduleSamples = {
  namespaced: true,
  state: {
    samples: [],
    loading: false,
  },
  getters: {
    getSamples(state) {
      return state.samples;
    },
    getLoading(state) {
      return state.loading;
    },
  },
  mutations: {
    loadSamples(state, samples) {
      state.samples = samples;
    },
  },
  actions: {
    async loadSamples({ commit, state, rootGetters }) {
      state.loading = true;
      commit("loadSamples", []);
      const rut = rootGetters["patient/getPatientRut"];
      let rutWithoutFormat = formatRut(rut);
      let rutWithoutPoint = rutWithoutFormat.replaceAll(".", "");

      let samples = await TomamuestraService.getSamples(rutWithoutPoint.split("-")[0]);
      commit("loadSamples", samples.sample);
      state.loading = false;
    },
  },
};

export default moduleSamples;
